<template>
  <header>
    <div
      class="
        header-bottom
        wrapper-padding-2
        res-header-sm
        sticker
        header-sticky-3
        furits-header
      "
    >
      <div class="container-fluid">
        <div class="header-bottom-wrapper">
          <div class="logo-2 ptb-35">
            <router-link class="page__title" to="/">Art Widgets</router-link>
          </div>
        </div>
        <div class="row">
          <div
            class="
              mobile-menu-area
              handicraft-menu
              d-md-block
              col-md-12 col-lg-12 col-12
              d-lg-none d-xl-none
            "
          >
            <!-- <div class="mobile-menu mean-container">
              <div class="mean-bar">
                <a
                  href="#nav"
                  class="meanmenu-reveal"
                  style="background: ; color: "
                  ><span></span><span></span><span></span
                ></a>
              </div>
              <div class="mean-push"></div>
              <nav id="mobile-menu-active" style="display: none">
                <ul class="menu-overflow">
                  <li><a href="index.html">Home</a></li>
                  <li><a href="shop.html">Shop</a></li>
                  <li><a href="shop-list.html">Shop List</a></li>
                </ul>
              </nav>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {
      active: "",
      spread: false,
      display: ""
    };
  },
  methods: {
    spreadNav() {
      this.spread = !this.spread;
      this.display = this.spread ? "block" : "none";
    }
  },
  mounted() {
    window.addEventListener("scroll", () => {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.active = scrollTop > 20 ? "top-nav-collapse" : "";
    });
  }
};
</script>

<style lang="scss" scoped>
.page__title {
  color: $green;
  font-size: 36px;
  font-weight: 900;
}
@media (max-width: 567px) {
  .page__title {
    font-size: 26px;
  }
  .ptb-35 {
    padding: 25px 0;
  }
  .furits-slider {
    padding-top: 120px;
  }
}
</style>
